@if (!!group.hiddenRatings || group.ratings.length) {
  <div layout-vertical layout-full-width>
    <div
      class="box-header"
      padding-left
      padding-top-small-x
      layout-horizontal
      layout-space-between
      layout-flex-1
    >
      @if (group.stage) {
        <div
          text-default-x
          layout-horizontal
          layout-align-items-center
          layout-flex-1
          layout-space-between
          padding-right-large
        >
          <rt-truncate text-weight-semi-bold text-darkest>
            {{ group.stage }}
          </rt-truncate>
          @if (hasMultiplePlacements()) {
            <rt-truncate margin-left-small-xx text-small text-light>
              {{ 'app.common.in' | translate }} {{ group.offer }}
            </rt-truncate>
          }
        </div>
      }
      @if (!group.stage) {
        <div text-weight-semi-bold text-darkest>
          {{ 'app.interview.group_no_stage' | translate }}
        </div>
      }
    </div>
    @if (group.hiddenRatings; as hiddenRating) {
      @if (hiddenEvaluationsInfoboxTpl(); as infoboxTpl) {
        <ng-container
          *ngTemplateOutlet="
            infoboxTpl;
            context: { $implicit: hiddenRating, hasAccessToJob: hasAccessToJob(group.offerId) }
          "
        />
      } @else {
        <rt-hidden-evaluations-infobox
          [count]="hiddenRating.count"
          [admins]="hiddenRating.admins"
          [guests]="hiddenRating.guests"
          [short]="true"
          [hasAccessToJob]="hasAccessToJob(group.offerId)"
          (counterClick)="onCounterClick()"
          margin-top-small-x
          margin-right
          margin-left
        />
      }
    }
    @for (rating of group.ratings; track trackBy($index, rating)) {
      <rt-overall-item-row [rating]="rating" [totalRatingsCount]="totalRatingsCount" />
    }
  </div>
}
